import { useContext } from 'react';

import { StepFive, StepFour, StepOne, StepThree, StepTwo } from '../Steps';

import { StepOneFormProvider } from '../../shared/contexts';
import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepFiveFormProvider } from '../Steps/StepFive/components/Form/contexts/StepFiveForm';
import { StepFourFormProvider } from '../Steps/StepFour/contexts/StepFourForm';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts/StepThreeForm';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts/StepTwoForm';
import { WizardDataFormProvider } from './contexts/WizardDataForm';

import { QuotationStep } from '../../shared/interfaces';
import { LoadSavedQuotation } from '../components/LoadSavedQuotation';
import { LoadRenewalQuotation } from '../components/LoadRenewalQuotation';

export const WizardFire = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } = useContext(QuotationInfoContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      case QuotationStep.FIVE:
        return <StepFive />;
      default:
        break;
    }
  };

  return (
    <StepOneFormProvider>
      <WizardDataFormProvider>
        <StepTwoFormProvider>
          <StepThreeFormProvider>
            <StepFourFormProvider>
              <StepFiveFormProvider>
                { loadingRenewalQuotation ? <LoadRenewalQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : getStepComponent() }
              </StepFiveFormProvider>
            </StepFourFormProvider>
          </StepThreeFormProvider>
        </StepTwoFormProvider>
      </WizardDataFormProvider>
    </StepOneFormProvider>
  );
};
